<template>
  <div class="">
    <section class="relative">
      <nav
        class="relative px-6 py-6 flex justify-between items-center bg-gray-50"
      >
        <router-link class="text-3xl font-bold leading-none" :to="{
              name: $store.state.app.activeGroup.publicPage.route,
              params: { id: $store.state.app.homePageId, cid: 0 }
            }">
          <img
            class="h-12"
            :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
            alt=""
            width="auto"
        /></router-link>
        <div class="lg:hidden">
          <button @click="showMobileNav=!showMobileNav" class="navbar-burger flex items-center text-gray-400 p-3">
            <svg
              class="block h-4 w-4 fill-current"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Mobile menu</title>
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"></path>
            </svg>
          </button>
        </div>
        <ul
          class="
            hidden
            absolute
            top-1/2
            left-1/2
            transform
            -translate-y-1/2 -translate-x-1/2
            lg:flex lg:mx-auto lg:flex lg:items-center lg:w-auto lg:space-x-6
          "
        >
          <li v-for="(p, i) in pages"
              :key="i" :class="{ 'group relative': getSub(p).length > 0 }">
            <router-link class="text-sm font-bold hover:text-yellow-600" 
            :class="{'text-green-600 ': p.id == $route.params.id }"
            :to="({name: $store.state.app.activeGroup.publicPage.route, params: {id: p.id, cid: 0} })"
              >{{p.task}}</router-link
            >
            <div class="group-hover:block hidden absolute t-0 h-auto p-3 bg-gray-300">
                <ul v-if="getSub(p).length" class="w-48">
                  <li  v-for="(s,i) in getSub(p)" :key="i" class="mb-3">
                    <a v-if="s.locTypeCode=='link'" :href="s.taskEn" target="_blank">
                      {{s.task}}
                    </a>
                    <router-link  class="font-bold"
                    v-else
                      
                      :to="({name: $store.state.app.activeGroup.publicPage.route, params: {id: s.id, cid: 0} })"
                    >
                      {{s.task}}
                    </router-link>
                  </li>
                </ul>
              </div>
          </li>
        </ul>
        <router-link
          class="
            hidden
            lg:inline-block
            py-2
            px-6
            hover:bg-gray-50
            text-sm
            font-bold
            rounded-l-xl rounded-t-xl
            transition
            duration-200
            text-white
            bg-green-600
            hover:bg-green-900
          "
          to="/login"
          >Нэвтрэх</router-link
        >
      </nav>
      
      <div :class="{'hidden': !showMobileNav}"
        class="
          navbar-menu
          fixed
          top-0
          left-0
          bottom-0
          w-5/6
          max-w-sm
          z-50
        "
      >
        <div @click="showMobileNav=false" class="navbar-backdrop fixed inset-0 bg-gray-800 opacity-25"></div>
        <nav
          class="
            relative
            flex flex-col
            py-6
            px-6
            h-full
            w-full
            bg-white
            border-r
            overflow-y-auto
          "
        >
          <div class="flex items-center mb-8">
            <a class="mr-auto text-3xl font-bold leading-none" href="#">
              <img
                class="h-10"
                :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
                alt=""
                width="auto"
            /></a>
            <button @click="showMobileNav=false" class="navbar-close">
              <svg
                class="h-6 w-6 text-gray-400 cursor-pointer hover:text-gray-500"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
          <div>
            <ul>
              <li class="mb-1">
                <a
                  class="
                    block
                    p-4
                    text-sm
                    font-semibold
                    text-gray-400
                    hover:bg-green-50 hover:text-green-600
                    rounded
                  "
                  href="#"
                  >Эхлэл</a
                >
              </li>
              
            </ul>
          </div>
          <div class="mt-auto">
            <div class="pt-6">
              <a
                class="
                  block
                  px-4
                  py-3
                  mb-2
                  leading-loose
                  text-xs text-center text-white
                  font-semibold
                  bg-green-600
                  hover:bg-green-700
                  rounded-l-xl rounded-t-xl
                "
                href="#"
                >Нэвтрэх</a
              >
            </div>
            <p class="my-4 text-xs text-center text-gray-400">
              <span>© 2022 GoSmart TM.</span>
            </p>
            <div class="text-center">
              <a class="inline-block px-1" href="#">
                <img :src="`${myResBaseUrl}atis-assets/social/facebook.svg`" alt=""
              /></a>
              <a class="inline-block px-1" href="#">
                <img :src="`${myResBaseUrl}atis-assets/social/twitter.svg`" alt=""
              /></a>
              <a class="inline-block px-1" href="#">
                <img :src="`${myResBaseUrl}atis-assets/social/instagram.svg`" alt=""
              /></a>
            </div>
          </div>
        </nav>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions } from "vuex";
var _ = require("lodash");

export default {
  data() {
    return {
      showMobileNav: false,
      pages: [],
      activeId: null,
      myResBaseUrl: "https://res.gosmart.mn/",
    };
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
  mounted() {

    this.init();
  },
  methods: {
    ...mapActions(["handleResponsiveLayoutConfig"]),
    mainMenuOpen() {
      let _obj = this.$store.state.app.responsiveLayout;
      _obj.navbarNavShow = true;
      _obj.backdrop.show = true;
      _obj.backdrop.onCloseEvent = 1;
      _obj.backdrop.removeClassName = "navbar-nav-show";
      this.handleResponsiveLayoutConfig(_obj).then(() => {
        this.toggleBodyClass("addClass", "navbar-nav-show");
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    init() {
      this.pages = _.sortBy(
        this.$store.state.app.pages.filter(
          (x) => x.i2 == 1 && x.i1 == 0 && x.parentId == 0
        ),
        "ord",
        "asc"
      );
    },
    getSub(p) {
      let pages = _.sortBy(
        this.$store.state.app.pages.filter(
          (x) => x.i2 == 1 && x.i1 == 0 && x.parentId == p.id
        ),
        "ord",
        "asc"
      );
      return pages;
    },
  },
  watch: {
    "$root.$route"() {
      this.activeId = null;
    },
  },
};
</script>
